import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts'

export function Hero() {
  const data = [
    { time: 'Jan 24', temp: 3.5, odo: 22 },
    { time: 'Jan 25', temp: 3.8, odo: 27 },
    { time: 'Jan 26', temp: 2.9, odo: 19 },
    { time: 'Jan 27', temp: 2.1, odo: 15 },
    { time: 'Jan 28', temp: 1.8, odo: 13 },
    { time: 'Jan 29', temp: 2.0, odo: 15 },
    { time: 'Jan 30', temp: 2.3, odo: 18 },
  ];

  return (
    <div className="w-full">
      {/* Hero Banner Section */}
      <div className="relative w-full" style={{ minHeight: '700px' }}>
        {/* Background Image */}
        <div
          className="absolute inset-0 bg-cover bg-center"
          style={{
            backgroundImage: 'url("/images/banner.png")',
            backgroundSize: 'cover',
            backgroundPosition: 'center',
          }}
        />

        {/* Overlay */}
        <div className="absolute inset-0 bg-gradient-to-r from-black/60 via-black/45 to-black/20" />

        {/* Content */}
        <div className="relative z-10 flex flex-col justify-center h-full px-4 sm:px-6 lg:px-[140px] pt-32 pb-40 ">
          <div className="max-w-[1920px] mx-auto w-full">
            <div className="max-w-2xl">
              {/* Main Title */}
              <h1 className="text-3xl font-bold text-white mb-6 leading-tight">
                Flood Warning System
              </h1>

              {/* Description Text */}
              <div className="max-w-2xl space-y-6">
                <p className="text-white text-lg md:text-xl leading-relaxed font-light">
                  Flash flooding often leaves only minutes to react before conditions approach dangerous levels. Flood warning systems save lives, protect property and limit damage to infrastructure by quickly alerting to heavy precipitation and changing water levels.
                </p>
                <p className="text-white text-lg md:text-xl leading-relaxed font-light">
                  An effective flood warning system enables authorities to take appropriate action, such as evacuation and control of dams in advance of a flood event, often leading to much less catastrophic outcomes when severe weather strikes.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Chart Card - Floating Section */}
      <div className="relative -mt-40 mb-16 px-4 sm:px-6 lg:px-[140px] z-20">
        <div className="max-w-[1920px] mx-auto">
          <div className="max-w-2xl">
            <div className="bg-white rounded-xl p-8 shadow-2xl">
              <h2 className="font-semibold text-lg mb-2">Flood Warning System</h2>
              <ResponsiveContainer width="100%" height={300}>
                <LineChart data={data} margin={{ top: 20, right: 30, left: 0, bottom: 0 }}>
                  <CartesianGrid strokeDasharray="3 3" />
                  <XAxis dataKey="time" />
                  <YAxis yAxisId="left" domain={[1, 4]} tickFormatter={v => `${v}°C`} />
                  <YAxis yAxisId="right" orientation="right" domain={[12, 28]} tickFormatter={v => `${v} mg/L`} />
                  <Tooltip />
                  <Legend />
                  <Line yAxisId="left" type="monotone" dataKey="temp" name="YSI Temperature (°C)" stroke="#20c997" strokeWidth={2} dot={false} />
                  <Line yAxisId="right" type="monotone" dataKey="odo" name="YSI ODO (mg/L)" stroke="#a259e6" strokeWidth={2} dot={false} />
                </LineChart>
              </ResponsiveContainer>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
